import {
    CART_SHOW_MINI_CART,
    PRODUCT_FILTERING_RECEIVE,
    PRODUCT_LISTING_SET_PRODUCTS,
} from '../constants';
import { dataLayerGtmViewCart, pushEcommerce } from '../Services/Gtm.service';

export const gtmMiddleware = ({ getState }) => (next) => (action) => {
  const { type, payload } = action;
  try {
    switch (type) {
      case CART_SHOW_MINI_CART:
        if (payload.showMiniCart) {
          gtmShowMiniCart(getState().cart);
        }
        break;
      case PRODUCT_FILTERING_RECEIVE:
        if (payload.hasOwnProperty('gtmViewModel') && payload.gtmViewModel !== null) {
          pushEcommerce(payload.gtmViewModel);
        }
        break;
      case PRODUCT_LISTING_SET_PRODUCTS:
        if (payload.hasOwnProperty('gtmViewModel') && payload.gtmViewModel !== null) {
          pushEcommerce(payload.gtmViewModel);
        }
        break;
    }
  } catch (err) {
    console.warn(err);
  }
  next(action);
};

const gtmShowMiniCart = ({ orderRows, gtmGrandTotal }) => {
  let currency = "";
  let gtmOrderRows = [];
  orderRows.map(row => {
    if (row.gtmEcommerceItem) {
      let gtmOrderRow = gtmOrderRows.find(e => e.item_id === row.articleNumber);
      if (gtmOrderRow) {
        if (gtmOrderRow.quantity) {
          gtmOrderRow.quantity += row.quantity;
        }
      } else {
        let gtmEcommerceItem = { ...row.gtmEcommerceItem };
        gtmEcommerceItem.quantity = row.quantity;
        gtmEcommerceItem.index = gtmOrderRows.length;
        gtmOrderRows.push(gtmEcommerceItem);
        currency = gtmEcommerceItem.currency ?? "";
      }
    }
  });
  
  if (gtmOrderRows.length > 0) {
    dataLayerGtmViewCart({currency, gtmGrandTotal, gtmOrderRows});
  }
}
